import Api from './api'

export default {
  getProposals (credentials) {
    return Api().get('administration/getproposals', credentials)
  },
  getProjects (credentials) {
    return Api().get('administration/getprojects', credentials)
  },
  getClients (credentials) {
    return Api().get('administration/getclients', credentials)
  },
  getProjectTypes (credentials) {
    return Api().get('administration/getprojecttypes', credentials)
  },
  nextJobId (credentials, params) {
    return Api().post('administration/nextjobid', credentials, params)
  },
  createProject(credentials, params) {
    return Api().post('administration/createproject', credentials, params)
  }  
}
